export const SET_TOKEN = "SET_TOKEN";
export const CLEAR_AUTH = "CLEAR_AUTH";
